export default "__VITE_ASSET__DAHoJvYH__"